/**
 * Flag to specify whether direction is vertical.
 */
export const MARGIN = 'margin';
export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const TOP = 'top';
export const SPACE_FIXER = 'spaceFixer';
export const CLASSPREFIX = 'muze';
export const VERTICAL_ALIGN = 'verticalAlign';
export const TEXT_ALIGN = 'textAlign';
export const IS_OFFSET = 'isOffset';
export const MIDDLE = 'middle';
export const BASELINE = 'baseline';
export const SHOW = 'show';
export const CENTER = 'center';
export const TEXT = 'text';
export const HEADER = 'header';
export const HEIGHT = 'height';
export const WIDTH = 'width';
export const DATA = 'data';
export const AXES = 'axes';
export const FACET_BY_FIELDS = 'facetByFields';
export const FIELDS = 'fields';
export const TRANSFORM = 'transform';
export const LAYER_DEF = 'layerDef';
export const CONFIG = 'config';
export const DETAIL_FIELDS = 'detailFields';
export const MAX_LINES = 'maxLines';
export const MIN_CHARS = 'minCharacters';
export const ROTATION = 'rotation';

export const TEXT_CELL = 'text-cell';
export const AXIS_CELL = 'axis-cell';
export const GEOM_CELL = 'geom-cell';
export const BLANK_CELL = 'blank-cell';

export const PADDING = 'padding';
export const HEADER_PADDING = 'headerPadding';
export const TITLE_PADDING = 'titlePadding';

export const TITLE = 'title';
export const SUBTITLE = 'subtitle';
